import {
  RESOURCE_LOADING,
  RESOURCE_SUCCESS,
  RESOURCE_FAILED
} from '../actions/resourcesActions'

const RESOURCES = (state = { isLoading: false }, action) => {
  switch (action.type) {
    case RESOURCE_LOADING:
      return { ...state,
        isLoading: true,
        error: null,
        resource: null
      }
    case RESOURCE_SUCCESS:
      return { ...state,
        isLoading: false,
        error: null,
        resource: action.response
      }
    case RESOURCE_FAILED:
      return { ...state,
        isLoading: false,
        error: null,
        resource: action.error
      }
    default:
      return state
  }
}

export default RESOURCES



// WEBPACK FOOTER //
// ./src/redux/reducers/resourcesReducer.js